interface tagType {
  type: string
  label: string
}

export const parsedProduct = (product: any) => {
  const getOffer = () => {
    if (Array.isArray(product.offer)) {
      return null
    }

    if (product.offer.value === 0) {
      return null
    }

    return {
      type: product.offer.type,
      label: product.offer.label,
      value: product.offer.value
    }
  }

  const getTag = () => {
    if (product.boitataFacets['free-shipping']) {
      return {
        type: 'freeShipping',
        label: 'Frete Grátis'
      }
    }

    if (product.relevanceFields.exclusiveMarkeplace) {
      return {
        type: 'exclusive',
        label: 'Exclusivo Site'
      }
    }

    if (product.relevanceFields.novelty) {
      return {
        type: 'news',
        label: 'NOVIDADE'
      }
    }

    if (product.boitataFacets['black-friday']) {
      return {
        type: 'outlet',
        label: 'Black Friday'
      }
    }

    return null
  }

  const getPrice = (type: string) => {
    if (!product.price[type]) {
      return null
    }

    const splitedPrice = String(product.price[type]?.toFixed(2)).split('.')

    return {
      integers: Number(splitedPrice[0]).toLocaleString(),
      decimals: splitedPrice[1]
    }
  }

  const isOutlet = (tag: tagType) => {
    return tag.type === 'outlet'
  }

  let tag = getTag()
  let hasOutlet = Boolean(tag && isOutlet(tag))

  const getInstallments = (installments: Object | Array) => {
    if (Array.isArray(installments)) {
      return null
    }

    return installments
  }

  const getDiscount = (discount: Object | Array) => {
    if (Array.isArray(discount)) {
      return {
        discountType: '',
        paymentMethodsDiscount: ''
      }
    }

    return discount
  }

  return {
    id: product.productID,
    shortName: product.name,
    picture: product.pictures.normal,
    unit: product.unit,
    inWishList: false,
    installments: getInstallments(product.installments),
    isOutlet: hasOutlet,
    tag,
    offer: getOffer(),
    price: {
      to: getPrice('promotionalPrice') ?? getPrice('promotional'),
      from: getPrice('originalPrice') ?? getPrice('original'),
      regionPrice: null,
      suggested: getPrice('suggestedPrice') ?? getPrice('suggested')
    },
    discount: getDiscount(product.discount),
    url: product.url,
    trackingUrl: null,
    assistedSale: false,
    isSoldOut: false,
    isExpressDelivery: false,
    expressDeliveryDay: true,
    name: product.name,
    services: false
  }
}
